// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    AddRequirementPayloadFolder,
    AddRequirementPayloadFolderFromJSON,
    AddRequirementPayloadFolderToJSON,
    CustomFieldCollectionOutput,
    CustomFieldCollectionOutputFromJSON,
    CustomFieldCollectionOutputToJSON,
    Milestone,
    MilestoneFromJSON,
    MilestoneToJSON,
    UserMinified,
    UserMinifiedFromJSON,
    UserMinifiedToJSON,
} from './';

/**
 * 
 * @export
 * @interface AddRequirementPayload
 */
export interface AddRequirementPayload {
    /**
     * 
     * @type {number}
     * @memberof AddRequirementPayload
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AddRequirementPayload
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof AddRequirementPayload
     */
    priority: AddRequirementPayloadPriorityEnum;
    /**
     * 
     * @type {number}
     * @memberof AddRequirementPayload
     */
    status: AddRequirementPayloadStatusEnum;
    /**
     * 
     * @type {Milestone}
     * @memberof AddRequirementPayload
     */
    milestone: Milestone;
    /**
     * 
     * @type {AddRequirementPayloadFolder}
     * @memberof AddRequirementPayload
     */
    folder?: AddRequirementPayloadFolder;
    /**
     * 
     * @type {UserMinified}
     * @memberof AddRequirementPayload
     */
    assignee?: UserMinified;
    /**
     * 
     * @type {UserMinified}
     * @memberof AddRequirementPayload
     */
    createdBy?: UserMinified;
    /**
     * 
     * @type {number}
     * @memberof AddRequirementPayload
     */
    created?: number;
    /**
     * 
     * @type {Array<CustomFieldCollectionOutput>}
     * @memberof AddRequirementPayload
     */
    customFields?: Array<CustomFieldCollectionOutput>;
}

export function AddRequirementPayloadFromJSON(json: any): AddRequirementPayload {
    return {
        'id': json['id'],
        'title': json['title'],
        'priority': json['priority'],
        'status': json['status'],
        'milestone': MilestoneFromJSON(json['milestone']),
        'folder': !exists(json, 'folder') ? undefined : AddRequirementPayloadFolderFromJSON(json['folder']),
        'assignee': !exists(json, 'assignee') ? undefined : UserMinifiedFromJSON(json['assignee']),
        'createdBy': !exists(json, 'created_by') ? undefined : UserMinifiedFromJSON(json['created_by']),
        'created': !exists(json, 'created') ? undefined : json['created'],
        'customFields': !exists(json, 'custom_fields') ? undefined : (json['custom_fields'] as Array<any>).map(CustomFieldCollectionOutputFromJSON),
    };
}

export function AddRequirementPayloadToJSON(value?: AddRequirementPayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'title': value.title,
        'priority': value.priority,
        'status': value.status,
        'milestone': MilestoneToJSON(value.milestone),
        'folder': AddRequirementPayloadFolderToJSON(value.folder),
        'assignee': UserMinifiedToJSON(value.assignee),
        'created_by': UserMinifiedToJSON(value.createdBy),
        'created': value.created,
        'custom_fields': value.customFields === undefined ? undefined : (value.customFields as Array<any>).map(CustomFieldCollectionOutputToJSON),
    };
}

/**
* @export
* @enum {string}
*/
export enum AddRequirementPayloadPriorityEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}
/**
* @export
* @enum {string}
*/
export enum AddRequirementPayloadStatusEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}


